import React, { useMemo } from 'react'
import classNames from 'classnames'

import passportImg from '../../assets/img/passportLogo.svg' // TODO: Fix vsc import error

import type { PassportBadgeProps } from './types'

/**
 *
 * @param sizePx: number - size of the badge in pixels
 * @default sizePx: 100
 * @returns PassportBadge component
 */
const PassportBadge = ({
  sizePx = 100,
  className = '',
}: PassportBadgeProps) => {
  const scale = useMemo(() => sizePx / 100, [sizePx])

  return (
    <div
      style={{
        transform: `scale(${scale})`,
      }}
      className={`passport-badge ${classNames({ [className]: !!className })}`}
    >
      <img
        className="passport-badge__logo"
        src={passportImg}
        alt={'passport logo'}
      />
    </div>
  )
}

export default PassportBadge
